// eslint-disable-next-line dmtrs-fsd-path-checker/layer-imports
import { IBreadcrumbItem } from '@/widgets/CustomBreadcrumbs';
import { routerPath } from '@/shared/config/router';

export const getTeacherCourseDetailBreadcrumbs = (courseTitle: string): IBreadcrumbItem[] => [
  { label: 'Courses', href: routerPath.teacherCourses },
  { label: courseTitle },
];

export const getTeacherGroupBreadcrumbs = (
  courseId: number,
  courseTitle: string,
  groupNumber: number,
  groupTitle?: string | null,
): IBreadcrumbItem[] => {
  const groupLabel = groupTitle?.trim()
    ? `${groupTitle} (Group ${groupNumber})`
    : `Group ${groupNumber}`;
  return [
    { label: 'Courses', href: routerPath.teacherCourses },
    {
      label: courseTitle,
      href: `${routerPath.teacherCourses}/${courseId}`,
      tooltip: courseTitle,
    },
    { label: groupLabel },
  ];
};

export const getTeacherTermDetailBreadcrumbs = (
  courseId: number,
  intakeId: number,
  courseTitle: string,
  groupNumber: number,
  groupTitle: string | undefined | null,
  termLabel: string,
): IBreadcrumbItem[] => {
  const groupLabel = groupTitle?.trim()
    ? `${groupTitle} (Group ${groupNumber})`
    : `Group ${groupNumber}`;
  const groupHref = routerPath.teacherCourseGroup
    .replace(':courseId', String(courseId))
    .replace(':intakeId', String(intakeId))
    .replace(':groupNumber', String(groupNumber));
  return [
    { label: 'Courses', href: routerPath.teacherCourses },
    {
      label: courseTitle,
      href: `${routerPath.teacherCourses}/${courseId}`,
      tooltip: courseTitle,
    },
    { label: groupLabel, href: groupHref },
    { label: termLabel },
  ];
};

const buildGroupLabel = (groupNumber: number, groupTitle?: string | null) =>
  groupTitle?.trim() ? `${groupTitle} (Group ${groupNumber})` : `Group ${groupNumber}`;

export const getTeacherModuleLessonsBreadcrumbs = (
  courseId: string,
  intakeId: string,
  courseTitle: string,
  groupNumber: string,
  groupTitle: string | undefined | null,
  termId: string,
  termLabel: string,
  moduleTitle: string,
): IBreadcrumbItem[] => {
  const groupLabel = buildGroupLabel(Number(groupNumber), groupTitle);
  const groupHref = routerPath.teacherCourseGroup
    .replace(':courseId', courseId)
    .replace(':intakeId', intakeId)
    .replace(':groupNumber', groupNumber);
  const termHref = routerPath.teacherCourseGroupTerm
    .replace(':courseId', courseId)
    .replace(':intakeId', intakeId)
    .replace(':groupNumber', groupNumber)
    .replace(':termId', termId);
  return [
    { label: 'Courses', href: routerPath.teacherCourses },
    { label: courseTitle, href: `${routerPath.teacherCourses}/${courseId}`, tooltip: courseTitle },
    { label: groupLabel, href: groupHref },
    { label: termLabel, href: termHref },
    { label: moduleTitle },
  ];
};

export const getTeacherModuleAttendanceBreadcrumbs = (
  courseId: string,
  intakeId: string,
  courseTitle: string,
  groupNumber: string,
  groupTitle: string | undefined | null,
  termId: string,
  termLabel: string,
  moduleTitle: string,
): IBreadcrumbItem[] => {
  const items = getTeacherModuleLessonsBreadcrumbs(
    courseId,
    intakeId,
    courseTitle,
    groupNumber,
    groupTitle,
    termId,
    termLabel,
    `Attendance "${moduleTitle}"`,
  );
  return items;
};
